import { _, $, Backbone, Radio } from "../../vendor";
import { Biscuit, Dependencies } from "../utils";
import { getUrlParameter, parseUrlIntoObject } from "../utils/Uri";
import InboomaBaseController from "./InboomaBaseController";

import Event from "../models/Event";
import Calendar from "../models/Calendar";
import Appointment from "../models/Appointment";

import Locations from "../collections/Locations";

import AppointmentsView from "../views/appointments/AppointmentsView";
import AppointmentsCalendarView from "../views/appointments/AppointmentsCalendarView";
import OffCanvasAppointmentsForm from "../views/appointments/OffCanvasAppointmentsForm";
import AppointmentsCalendarForm from "../views/appointments/AppointmentsCalendarForm";
import EventRescheduleForm from "../views/appointments/EventRescheduleForm";
import OffCanvasOrdersForm from "../views/orders/OffCanvasOrdersForm";

import AppointmentsViewTpl from "../templates/appointments/AppointmentsViewTpl.html";

export default InboomaBaseController.extend({
  _channelName: "calendars",
  _el: "#inb-c-main-appointments",
  calendar_id: "",

  _alreadySetEvents: false,

  /**
   * @routes /appointments
   *         /appointments/:cid
   *
   * @todo Updating appointments (e.g. via appointmentsView.toggleBlockState) does not
   *       lead to a proper re-render of calendar.
   */
  index(cid = null, forceRender = false) {
    this._updateCollection();

    const that = this,
      render = this._shouldRenderLayout();

    if (render && !that._alreadySetEvents) {
      this.setLayout(
        `
          <aside>
            <div id="inb-app-appointments-load" class="inb-announcement" style="margin-top:80px;position:absolute;width:100%;">
              <img src="assets/img/manage_locations.svg" style="max-width:300px" /> 
            </div>
          </aside>`,
        {},
        true,
      );
    }

    this.appointments = Radio.channel("appointments").request("get:data");

    if (typeof this.appointmentsCalendarView !== "undefined") {
      // @todo this.appointments.refetch (make sure that code below becomes executed nevertheless)
    }

    if (typeof getUrlParameter("forceRefresh") !== "undefined") {
      forceRender = true;
    }

    this._alreadySetEvents = true;

    // @todo: If no calendar existing, hide "add event" button

    if (cid) {
      _.each(that._collection.models, (calendar, key) => {
        if (Number(cid) === calendar.get("id")) {
          that.calendar_id = Number(cid);
          that.events = calendar.get("events");
        }
      });

      if (typeof this.events == "undefined") {
        alert("Wrong calendar_id, calendar not existing :(");
        Backbone.history.navigate("appointments", { trigger: true });
        resolve();
      }
    } else {
      if (typeof this._collection.models[0] === "undefined") {
        // No calendar set - throw notification and render
        // calendarForm, though invisible

        this.setLayout(AppointmentsViewTpl, {
          _,
          calendars: this._collection,
          active_calendar: this.calendar_id,
        });

        $("#inb-c-main-calendars,.app-appointment-wrapper").hide();

        $("#inb-modal-calendars").before(`
                  <div id="inb-app-appointments-no-calendar" class="inb-announcement" style="margin:0 auto;margin-top:80px;">
                    <img src="assets/img/spreadsheet_sad.svg" style="max-width:250px" />
                    <h3>No calendar found.</h3>
                    <p>
                      <a href="appointments/calendars/add">
                        + ${that.t("add_${a}", { a: that.t("calendar") })}
                      </a>
                    </p>
                  </div>
              `);

        return;
      } else {
        if (this.calendar_id == "") {
          this.calendar_id = this._collection.models[0].get("id");
        }

        this.events = this._collection.get(this.calendar_id).get("events");
      }
    }

    _.each(this.appointments.models, (appointment) => {
      // Append appointment to its event sibling
      // This is not about performance or SOC but
      // the fastest solution available
      const event = that.events.get(appointment.get("event_id"));

      if (typeof event !== "undefined") {
        if (typeof event.attributes.appointments == "undefined") {
          event.attributes.appointments = [];
        }
        event.attributes.appointments.push(appointment.toJSON());
      }
    });

    // set global template
    this.setLayout(AppointmentsViewTpl, {
      _,
      calendars: this._collection,
      active_calendar: this.calendar_id,
    });

    if (0 === document.getElementsByClassName("calendar-contingent-item").length) {
      this.appointmentsCalendarView = new AppointmentsCalendarView({
        collection: this._collection,
        active_calendar: this.calendar_id,
      });
    }

    this.app.trigger("change:view", "appointments");

    this.appointmentsView = new AppointmentsView({
      collection: that.events,
      contingents: that._collection.get(that.calendar_id).get("contingents"),
      all_contingents: Radio.channel("contingents").request("get:data"),
      appointments: that.appointments,
      active_calendar: that.calendar_id,
      toggleAppointment: null, //appointmentId,
      widgetMode: false, //that.widgetMode,
    });
  },

  /**
   * @routes /appointments/:id/event/:eid/block/:options
   */
  block(cid = null, eid = null) {
    this.index(cid);

    this.appointmentsView.toggleBlockState(eid);
  },

  openOrdersForm(orderId, reservationId) {
    const orders = Radio.channel("orders").request("get:data");

    new Dependencies({
      locations: new Locations(),
    }).then(() => {
      const ordersForm = new OffCanvasOrdersForm({
        model: orders.get(orderId),
        toggleAddReservation: false,
        toggleReservation: reservationId,
        collection: orders,
      });

      ordersForm.afterCloseTriggerNavigate = false;
      ordersForm.parentView = "appointments";
    });
  },

  /**
   *  @routes /appointments/:cid/add
   *          /appointments/:cid/event/:eid/edit
   */
  appointmentsForm(cid = null, eid = null) {
    // @todo: Extract .then contents, call only if view not
    // yet rendered

    this.index(cid);

    // Attention - id always binded to currently opened calendar
    const model = eid === null ? new Event() : this._collection.get(cid).get("events").get(eid);

    if (model.get("calendar_id") == "") {
      model.set("calendar_id", this.calendar_id);
    }

    new OffCanvasAppointmentsForm({
      model: model,
      collection: this._collection.get(model.get("calendar_id")).get("events"),
      calendar: this._collection.get(model.get("calendar_id")),
    });
  },

  reschedule(cid = null, eid = null, options = null) {
    if (cid && eid && options) {
      this.index(cid);

      const event = this.events.get(eid),
        request = parseUrlIntoObject();

      let model;

      if (typeof request.appointment_id == "undefined") {
        const contingent = this._collection.get(this.calendar_id).get("contingents").models[0];

        model = new Appointment({
          client_id: Biscuit.get("user.client_id"),
          name: event.get("title"),
          description: "action:reschedule",
          max_pers_count: contingent.get("number_active"),
          current_available_pers_count: contingent.get("number_active"),
          contingent_id: contingent.get("id"),
          event_id: eid,
          begin: request.start,
          end: request.end,
        });
      } else {
        model = this.appointments.get(request.appointment_id);
      }

      const eventRescheduleForm = new EventRescheduleForm({
        model,
        active_calendar_id: this.calendar_id,
        collection: this.appointments,
      });

      const that = this;

      eventRescheduleForm.on("updated", () => {
        that.index(null, true);
      });
    }
  },

  /**
   *  @routes /appointments/calendars/add
   *          /appointments/calendars/:id
   */
  appointmentsCalendarForm(cid = null) {
    if (this._shouldRenderLayout()) {
      this.index(cid);
    }

    const model =
      cid === null
        ? new Calendar({ client_id: Biscuit.get("user.client_id") })
        : this._collection.get(cid);

    new AppointmentsCalendarForm({
      model,
      collection: this._collection,
    });
  },
});
